const LockedBadge = () => (
  <span className="badge text-bg-secondary ms-2">Exercice verrouillé</span>
);

export default LockedBadge;
